module.exports = __webpack_public_path__ + "media/images/edion/en/discount-coupon-ec4d8cfe98a97b714e1abecb03ab719c.png";